<div [class]="classPrefix('MainPod')">
  <section [class]="classPrefix('Pod0')">
    <job-status-zero [props]="props.jobInfo"></job-status-zero>
  </section>
</div>
